import React from "react";

const LoadTileLeft = (props: any) => {
  const stopOffs = props.numberOfStops - 2;

  return (
    <div>
      <p className="card_p-elements loadno_card">
        {props.showLoadNo ? props.shipmentId : ""}
      </p>
      <p className="card_p-elements card-contact_for_price">{props.loadId}</p>
      {props.totalDistance ? (
        <p
          className={`card-distance ${props.showLoadNo ? "no-margin" : ""}`}
          data-test="card-distance"
        >
          {Math.round(props.totalDistance)} miles
        </p>
      ) : null}
      {stopOffs > 0 && (
        <p className="card-stopOffs" data-test="stop-offs">
          {stopOffs > 1 ? `${stopOffs} Stop offs` : `${stopOffs} Stop off`}
        </p>
      )}
      <p className="card_p-elements card-trailerType">
        {props.isCarrierLoad ? props.equipmentType : props.capacityType}
      </p>
      <p className="card_p-elements card-lbs">
        {props.totalWeight &&
          props.totalWeight
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
        {props.weightUOM}
      </p>
      {props.isHazardous && (
        <p className="card_p-elements card-hazmat" data-test="is-Hazardous">
          Hazmat
        </p>
      )}
      {props.isHighValue && (
        <p className="card_p-elements card-value" data-test="is-HighValue">
          High Value
        </p>
      )}
      {(props.specialServices &&
        props.specialServices.length &&
        props.specialServices.map((service: any, index: any) => (
          <p className="card_p-elements card-value" key={index}>
            {service.specialServiceDesc}
          </p>
        ))) ||
        null}
      {/* {(props.shipmentServices &&
        props.shipmentServices.length &&
        props.shipmentServices.map((service: any, index: any) => (
          <p className="card_p-elements card-value" key={index}>
            {service.serviceDescription}
          </p>
        ))) ||
        null} */}
      {props.isTemperatureControlled && (
        <p className="card_p-elements card-value" data-test="is-temperature">
          Temperature Control
        </p>
      )}
    </div>
  );
};

export default LoadTileLeft;
